// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_exn = require("rescript/lib/js/js_exn.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");

var isString = (obj => typeof obj === 'string');

var isBool = (obj => typeof obj === 'boolean');

var isArray = (obj => Array.isArray(obj));

var isObject = (obj => obj !== undefined && obj !== null && !Array.isArray(obj) && typeof obj === 'object');

var isFunction = (obj => typeof obj === 'function');

function reqExn(nullable, msg) {
  if (nullable == null) {
    return Js_exn.raiseError("A required attribute is missing: " + msg);
  } else {
    return nullable;
  }
}

function reqStrExn(nullable, msg) {
  var res = reqExn(nullable, msg);
  if (isString(res)) {
    return res;
  } else {
    return Js_exn.raiseError("Not a string: " + msg);
  }
}

function optStrExn(nullable, msg) {
  if (!(nullable == null)) {
    if (isString(nullable)) {
      return nullable;
    } else {
      return Js_exn.raiseError("Not a string: " + msg);
    }
  }
  
}

function reqBoolExn(nullable, msg) {
  var res = reqExn(nullable, msg);
  if (isBool(res)) {
    return res;
  } else {
    return Js_exn.raiseError("Not a boolean: " + msg);
  }
}

function optBoolExn(nullable, msg) {
  if (!(nullable == null)) {
    if (isBool(nullable)) {
      return nullable;
    } else {
      return Js_exn.raiseError("Not a boolean: " + msg);
    }
  }
  
}

function reqArrExn(nullable, msg) {
  var res = reqExn(nullable, msg);
  if (isArray(res)) {
    return res;
  } else {
    return Js_exn.raiseError("Not an array: " + msg);
  }
}

function reqObjExn(nullable, msg) {
  var res = reqExn(nullable, msg);
  if (isObject(res)) {
    return res;
  } else {
    return Js_exn.raiseError("Not an object: " + msg);
  }
}

function optObjExn(nullable, msg) {
  if (!(nullable == null)) {
    if (isObject(nullable)) {
      return Caml_option.some(nullable);
    } else {
      return Js_exn.raiseError("Not an object: " + msg);
    }
  }
  
}

function reqFuncExn(nullable, msg) {
  var res = reqExn(nullable, msg);
  if (isFunction(res)) {
    return res;
  } else {
    return Js_exn.raiseError("Not a function: " + msg);
  }
}

function invokeExnFunc(title, func) {
  try {
    return {
            TAG: "Ok",
            _0: func()
          };
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === Js_exn.$$Error) {
      var exn$1 = exn._1;
      var errMsg = title + ": " + Belt_Option.getWithDefault(exn$1.message, "unknown error.") + ".";
      var stack = Belt_Option.getWithDefault(exn$1.stack, "");
      return {
              TAG: "Error",
              _0: [
                  errMsg,
                  stack
                ].join("\n")
            };
    }
    var errMsg$1 = title + ": unknown error.";
    return {
            TAG: "Error",
            _0: errMsg$1
          };
  }
}

var executeFunctionBody = (body => new Function("", body)());

exports.isString = isString;
exports.isBool = isBool;
exports.isArray = isArray;
exports.isObject = isObject;
exports.isFunction = isFunction;
exports.reqStrExn = reqStrExn;
exports.optStrExn = optStrExn;
exports.reqBoolExn = reqBoolExn;
exports.optBoolExn = optBoolExn;
exports.reqArrExn = reqArrExn;
exports.reqObjExn = reqObjExn;
exports.optObjExn = optObjExn;
exports.reqFuncExn = reqFuncExn;
exports.invokeExnFunc = invokeExnFunc;
exports.executeFunctionBody = executeFunctionBody;
/* No side effect */
